var chunkMapping = {
	"3032": [
		63032
	],
	"7686": [
		7686
	]
};
var idToExternalAndNameMapping = {
	"7686": [
		"default",
		"./components/CommonHeader",
		36547
	],
	"63032": [
		"default",
		"./components/CommonFooter",
		36547
	]
};
var idToRemoteMap = {
	"7686": [
		{
			"externalType": "script",
			"name": "fe_common"
		}
	],
	"63032": [
		{
			"externalType": "script",
			"name": "fe_common"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"7686": {
		"shareScope": "default",
		"name": "./components/CommonHeader",
		"externalModuleId": 36547,
		"remoteName": "fe_common"
	},
	"63032": {
		"shareScope": "default",
		"name": "./components/CommonFooter",
		"externalModuleId": 36547,
		"remoteName": "fe_common"
	}
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}